import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Stack } from '@mui/material';

import { Modal } from 'components/Modal';
import { FormProvider, TextField } from 'components/Form';
import useYupValidationResolver from 'hook/useYupValidationResolver';

import { useCreateLevel } from '../api/createLevel';
import { useUpdateLevel } from '../api/updateLevel';
import { levelValidationSchema } from '../validation';

export const LevelFormModal = ({
  resource,
  id,
  structureId,
  level,
  open,
  handleClose,
  onSaved,
}) => {
  const isEdit = !!level?.level_id;

  const methods = useForm({
    defaultValues: { name: '', description: '' },
    resolver: useYupValidationResolver(levelValidationSchema),
  });

  const onSuccess = () => {
    onSaved();
    handleClose();
  };
  const { mutateAsync: createLevel } = useCreateLevel(resource, id, onSuccess);
  const { mutateAsync: updateLevel } = useUpdateLevel(resource, id, onSuccess);

  const { reset } = methods;
  useEffect(() => {
    if (open) {
      reset({ name: level?.name ?? '', description: level?.description ?? '' });
    }
  }, [open, level, reset]);

  const onSubmit = (values) => {
    const request = isEdit
      ? updateLevel({ structureId, levelId: level.level_id, ...values })
      : createLevel({ structureId, ...values });
    request.catch(() => {});
  };

  return (
    <Modal title={isEdit ? 'Edit level' : 'Add level'} open={open} handleClose={handleClose}>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <Stack gap={3} mb={3}>
          <TextField fullWidth name="name" label="Name" placeholder="Please enter name" required />
          <TextField
            fullWidth
            name="description"
            label="Description"
            placeholder="Please enter description"
            multiline
            minRows={3}
            sx={{ '& .MuiInputBase-root': { p: 0 } }}
          />
        </Stack>

        <Stack direction="row" gap={3} justifyContent="center">
          <Button variant="outlined" color="primary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" type="submit">
            {isEdit ? 'Update' : 'Add'}
          </Button>
        </Stack>
      </FormProvider>
    </Modal>
  );
};
